import { useEffect } from 'react';
import UserContextProvider from '../shared/context/UserContext';
import { IconButton, ThemeProvider } from '@airbus/components-react';
import AllScreensDetailsContextProvider from '../shared/context/AllScreensDetailsContext';
import ServiceWorkerContextProvider, {
  initServiceWorker,
} from '../shared/context/ServiceWorkerContext';
import { NotificationContextProvider, useNotificationContext } from '../shared/context/NotificationContext';
import { Close } from '@mui/icons-material';
import styles from './_app.module.css';
import NotificationTabsPanel from '../shared/components/NotificationTabsPanel';
import { useLanguageContextAPI } from '../shared/context/LanguageContext';
import { Outlet } from 'react-router';
import { initializeNotificationWorkflow } from '../features/notifications/workflow';

function MyApp() {
  useEffect(() => {
    initializeNotificationWorkflow();

    const installSvcWorker = async () => await initServiceWorker();
    installSvcWorker();
  }, []);

  return (
    <>
      <NotificationContextProvider>
        <UserContextProvider>
          <AllScreensDetailsContextProvider>
            <ServiceWorkerContextProvider>
              <ThemeProvider brand='airbus'>
                <ComponentAndNotificationPanel />
                <Outlet />
              </ThemeProvider>
            </ServiceWorkerContextProvider>
          </AllScreensDetailsContextProvider>
        </UserContextProvider>
      </NotificationContextProvider>
    </>
  );
}

export default MyApp;

function ComponentAndNotificationPanel() {
  const { isNotificationPanelOpen, setNotificationPanelOpen } = useNotificationContext();
  const { t } = useLanguageContextAPI();

  return (
    <>
      {isNotificationPanelOpen && (
        <div
          className={styles.notificationOverlay}
          onClick={() => setNotificationPanelOpen(false)}
        />
      )}
      <div
        className={
          styles.notificationPanel +
          (isNotificationPanelOpen ? ' ' + styles.notificationPanelOpen : '')
        }
      >
        <div className={styles.notificationHeader}>
          <h3 className={styles.notificationTitle}> {t('notification_panel.notifications')}</h3>

          <IconButton
            variant='ghost'
            size='xsmall'
            aria-label='Close notifications'
            onClick={() => setNotificationPanelOpen(false)}
          >
            <Close />
          </IconButton>
        </div>
        <div>
          <NotificationTabsPanel />
        </div>
      </div>
    </>
  );
}
